import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ zx }) => zx && css`
    .popup {
      z-index: ${zx} !important;
    }
  `}
`

export const ModalDialog = styled.div`
  position: relative;
  background-color: ${({ theme, isTransparent }) => isTransparent ? 'transparent' : theme.colors.backgroundColor};
  padding: ${({ padding }) => padding || '0px'};
  width: 100%;
  max-width: calc(100vw - 32px);
  border-radius: 10px;
  box-sizing: border-box;
  margin: auto;
  height: ${({ height }) => height || 'auto'};
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    width: ${({ width }) => width || '50%'};
    max-height: 90vh;
  }
`

export const ModalBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const ModalHeader = styled.div`
  display: flex;
  direction: ${({ theme }) => theme.rtl ? 'rtl' : 'ltr'};
`

export const ModalTitle = styled.h2`
  text-align: ${({ theme }) => theme.rtl ? 'right' : 'left'};
  font-size: 22px;
  letter-spacing: 0px;
  color: #010300;
  opacity: 1;
  margin: 0px 0px;
  margin-bottom: 16px;
  ${({ theme }) => theme.rtl ? css`
    padding-right: 10px;
    padding-left: 36px;
  ` : css`
    padding-left: 10px;
    padding-right: 36px;
  `}
  text-transform: capitalize;
  flex: 1;
  line-height: 1.3;
  word-break: break-word;
`

export const ModalOrderTypes = styled.div`
  margin-right: 15px;
`
export const ModalIcon = styled.span`
  position: fixed;
  ${({ theme }) => theme.rtl ? 'left: 15px;' : 'right: 15px;'}
  top: 10px;
  font-size: 24px;
  cursor: pointer;
  z-index: 2;
  svg{
    border-radius: 50%;
  }

  @media(min-width: 769px){
    position: absolute;
  }
`
